/**
 * Resolves the slug of the context the user is currently in — a payment link,
 * invoice/quote/agreement/product slug on the public action routes, or the
 * encoded clusterid slug on the logged-in portal routes.
 *
 * The number is the index of the slug segment within the path, e.g.
 * `/payment_link/:id` -> 1, `/payments/:type/:id` -> 2.
 */
const SLUG_ROUTES: Record<string, number> = {
  payment_link: 1,
  invoice: 1,
  quotes: 1,
  agreement: 1,
  product: 1,
  "view-payment": 1,
  "subscriptions-plans": 2, // /subscriptions-plans/:type/:id
  "payment-methods": 2, // /payment-methods/update/:id
  payments: 2, // /payments/:type/:id
};

export const getCurrentSlug = (
  pathname: string = typeof window !== "undefined"
    ? window.location.pathname
    : ""
): string => {
  const segments = pathname.split("/").filter(Boolean);

  if (!segments.length) return "";

  const slugIndex = SLUG_ROUTES[segments[0]];

  // anything else is a portal route — `/:clusterId/...`
  return (slugIndex === undefined ? segments[0] : segments[slugIndex]) || "";
};

/**
 * Unprotected `/payment/*` routes have no auth middleware to derive the tenant
 * from, so they need the clusterid slug passed explicitly on every request —
 * in the body for POSTs, in the query for GETs.
 */
export const withSlug = <T extends Record<string, any> | undefined>(
  data?: T
) => ({
  ...(data as Record<string, any>),
  slug: data?.slug || getCurrentSlug(),
});

export default getCurrentSlug;
